import { render } from "./Origence.vue?vue&type=template&id=a1e798de"
import script from "./Origence.vue?vue&type=script&lang=js"
export * from "./Origence.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__